import { RemoveCircle } from '@mui/icons-material';
import { Box, IconButton, Paper, Typography, styled } from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
    border: `1px dashed #37326E`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(1)
}));

interface FileCardProps {
    file: File | null;
    onRemove?: () => void;
}

const FileCard = ({ file, onRemove }: FileCardProps) => {
    if (!file) return null;
    const fileName = file.name;
    const description = file.type;
    const fileSize = `${(file.size / 1024).toFixed(2)} KB`;

    return (
        <StyledPaper elevation={0}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body1" component="span" fontWeight="medium" color={file.type ? 'primary' : 'text.primary'}>
                    {fileName}
                </Typography>
                {description && (
                    <Typography variant="body1" color="text.secondary">
                        {description}
                    </Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {fileSize}
                </Typography>
                <IconButton onClick={onRemove} color="error" size="small" aria-label="remove file">
                    <RemoveCircle />
                </IconButton>
            </Box>
        </StyledPaper>
    );
};

export default FileCard;
